import React, { useState } from 'react'
import { useSelector } from 'react-redux';

function FontDropdown({ selectedSize,setSelectedSize,fontKey,handleChange  }) {
    const fonts = [1, 2, 3, 4, 5, 6,];
    const handleSizeChange = (e) => {
        setSelectedSize({ ...selectedSize, [fontKey]: e.target.value });
    };
    return (
        <>
            <div className='font-dropdown'>
            <input type="number" onChange={handleChange} min={1} max={6} name={fontKey} value={selectedSize[fontKey] ? selectedSize[fontKey] : (fontKey === 'title_size' ? 6 : 4)}/>
            <span>/6</span>                  
                {/* <ul className="font-dropdown-menu dropdown-menu" style={{ borderRadius: "15px" }} aria-labelledby="header-share-dropdown">
                {
                    fonts.filter((val) => val !== selectedSize[fontKey]).map((val, index) => (
                        <li className='w-100' key={index}>
                            <div 
                                onClick={() => handleSizeChange(val)} 
                                className="share-dropdown-item exclude-hover share-dropdown-text d-flex justify-content-start align-items-center"
                            >
                                {val}
                            </div>
                        </li>
                    ))
                }
                </ul> */}
            </div>
        </>
    )
}

export default FontDropdown